import { atom } from "recoil";


const storeState = atom({
    key: 'currentStore',
    default: {},
});
  
export default storeState;